import { useNavigate } from "react-router";
import { url } from "../../../../utils/url";
import { styled as _styled } from "@mui/material/styles";
import { Root, Text, ButtonLog, ButtonLogCreateAccount } from "./styles";

export const LoginArea = () => {
    let navigate = useNavigate();
    return (
        <>
            <Root>
                {/* <ButtonLogCreateAccount
                    onClick={() => navigate(url.login)}>
                    <Text>Załóż konto</Text>
                </ButtonLogCreateAccount> */}
                <ButtonLog onClick={() => navigate(url.login)}>
                    <Text>Zaloguj się</Text>
                </ButtonLog>

            </Root>

        </>
    );
};

